<div class="card mb-3 p-3 " (click)="openDetailModal($event)" style="cursor: pointer;">
    <div class="row pb-3" style="border-bottom: 1px solid #f0f0f0">
        <div class="col col-9 d-flex align-items-center">
            <div class="row">
                <div class="d-flex align-items-center pl-2">
                    <img 
                    [src]="img"
                    alt="Auction item image"
                    style="width: 144px;border-radius: 4px;">
                </div>
                <div class="col col-10.5 pl-4 d-flex align-items-center">
                    <span class="body-1 cursor--pointer">{{auctionItem.name}}</span>
                </div>
            </div>
        </div>
        <div class="col col-2.5 d-flex justify-content-start align-items-end flex-column">
                <app-shared-link-option-popover *ngIf="auctionType !== 1" [campaign]="auction" [option]="auctionItem"></app-shared-link-option-popover>
                <div class="d-flex flex-row align-items-center mt-3">
                    <span class="caption grey-text mr-2" *ngIf="!auctionItem.buyItNowOnlyItem && auctionItem.currentBid == 0">Starting Bid</span>
                    <span class="caption grey-text mr-2" *ngIf="!auctionItem.buyItNowOnlyItem && auctionItem.currentBid !== 0">Current Bid</span>
                    <span class="caption grey-text mr-2" *ngIf="auctionItem.buyItNowOnlyItem">Buy It Now</span>
                    <span class="subtitle-1" *ngIf="!auctionItem.buyItNowOnlyItem && auctionItem.currentBid !== 0">{{getNumberStr(auctionItem.currentBid)}}</span>
                    <span class="subtitle-1" *ngIf="auctionItem.buyItNowOnlyItem">{{getNumberStr(auctionItem.buyItNowAmount)}}</span>
                    <span class="subtitle-1" *ngIf="!auctionItem.buyItNowOnlyItem && auctionItem.currentBid == 0">{{getNumberStr(auctionItem.minBid)}}</span>
                </div>
        </div>
    </div>
    
    <div class='datail-info d-flex justify-content-between pt-3'>
        <div class="d-flex align-items-center">
            <div class="body-2">
                <span [ngClass]="soldOut ? 'red-text': 'grey-text' ">
                    <b>{{soldCount}}</b> of <b>{{auctionItem.count}}</b>
                </span> 
                <span [ngClass]="soldOut ? 'red-text': 'blue-text'" class="mr-2"> Sold</span> 
                <span class="orange-text">See All Bidders ></span> </div>
        </div>
        <div class="d-flex align-items-center">
            <div class="d-flex justify-content-end" style="min-width: 80px;">
                <div class="d-flex align-items-center caption mr-2" *ngIf="!auctionItem.buyItNowOnlyItem">
                    <span class="caption grey-text mr-1" >Min:</span>{{getNumberStr(auctionItem.minBid)}}
                </div>
            </div>
        </div>
    </div>
</div>
